import { createSlice } from '@reduxjs/toolkit';
import { SiteSearchState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { siteSearchThunk } from './thunks';

const initialState: SiteSearchState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

export const siteSearchSlice = createSlice({
  name: 'siteSearch',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(siteSearchThunk.pending, (state) => {
      state.status = StoreStatus.BUSY;
      state.errors = null;
    });

    builder.addCase(siteSearchThunk.fulfilled, (state, action) => {
      state.status = StoreStatus.IDLE;
      state.errors = null;

      const isLoadMore = Boolean(action.meta.arg.nextToken);

      if (isLoadMore && state.response) {
        state.response = {
          items: [...state.response.items, ...action.payload.items],
          nextToken: action.payload.nextToken,
        };
      } else {
        state.response = action.payload;
      }
    });

    builder.addCase(siteSearchThunk.rejected, (state, { payload }) => {
      state.status = StoreStatus.ERROR;
      state.errors = payload;
    });
  },
});

export const { reset } = siteSearchSlice.actions;
export * from './thunks';
export * from './selectors';
export * from './types';
export default siteSearchSlice.reducer;
